/* global $, leaderboard_settings, query_string, data */
/* eslint-disable no-use-before-define */
import _ from 'underscore'
import Table from 'bam-node-savant-table/table'
import { guff } from 'bam-node-baseball-savant/utils/guff'

import { teamMapAbbrev } from 'bam-node-baseball-savant/constants/teams'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'sprint_speed'

$(document).ready(() => {
    const $typeSelect = document.getElementById('ddlType')
    $('#ddlTeam').change(() => {
        $('#lblTeam').html(
            `Team: ${$('#ddlTeam option:selected').text() || 'All'}`
        )
    })
    $('#ddlPosition').change(() => {
        $('#lblPosition').html($('#ddlPosition option:selected').text())
    })

    $typeSelect.addEventListener('change', (e) => {
        document.getElementById('lblType').innerText = `Type: ${e.target.value}`
    })

    document.getElementById('ddlSeason').addEventListener('change', (e) => {
        document.getElementById(
            'lblSeason'
        ).innerText = `Season: ${e.target.value}`
    })

    if (query_string.season) {
        // Set min year select
        document.getElementById('ddlSeason').value = query_string.season
        document.getElementById(
            'lblSeason'
        ).innerText = `Season: ${query_string.season}`
    }

    if (query_string.team) {
        $('#ddlTeam').val(query_string.team).attr('selected', true)
        $('#lblTeam').html($('#ddlTeam option:selected').text())
    }

    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    $('form').submit(false)

    if (data && data.length > 0) {
        let dataLoad = data
        if (query_string.team && teamMapAbbrev[query_string.team]) {
            dataLoad = _.filter(
                dataLoad,
                (d) => d.team_id === teamMapAbbrev[query_string.team].id
            )
        }

        const headers = [
            {
                name: 'Team',
                field: 'name_display_club',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
            },
            {
                name: 'Year',
                field: 'timeframe',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Number of Players',
                field: 'Num_players',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Competitive Runs',
                field: 'Num_competitive_runs',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'Bolts',
                field: 'N_bolts',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
            {
                name: 'HP to 1B',
                field: 'avg_HP_to_1B',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
                displayFn: (val) => guff(val, 'home_to_first'),
            },

            {
                name: 'Sprint Speed (ft / sec)',
                field: 'avg_sprint_speed',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data sprint-speed-size',
                highlight: [26, 27, 28],
                displayFn: (val) => guff(val, 'sprint_speed'),
            },
            {
                name: 'Fastest Player<br/> Sprint Speed',
                field: 'fastest_sprint_speed',
                type: 'number',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data sprint-speed-size',
                displayFn: (val) => guff(val, 'sprint_speed'),
            },
        ]

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        const defaultSort = query_string.sortColumn || 'avg_sprint_speed'
        const defaultSortDirection = query_string.sortDirection || 'desc'

        // eslint-disable-next-line no-new
        new Table({
            id: 'sprint_speed',
            repeatHeader: repeatHeaders,
            headers,
            data: dataLoad,
            defaultSort,
            defaultSortDirection,
            sortClass: 'column-sort',
            showRank: true,

            sortCallback(column, __, { state }) {
                const url = new URL(window.location)
                url.searchParams.set('sortColumn', column)
                url.searchParams.set('sortDirection', state)
                window.history.replaceState('', '', url.toString())
            },
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    function getUrl() {
        return `/leaderboard/sprint-speed-team?season=${$(
            '#ddlSeason'
        ).val()}&team=${$('#ddlTeam').val()}`
    }

    function getPlayerUrl() {
        let season = document.getElementById('ddlSeason').value
        if (season === 'all') {
            season = leaderboard_settings.year
        }
        const team = document.getElementById('ddlTeam').value
        return `/leaderboard/sprint_speed?min_season=${season}&max_season=${season}&team=${team}`
    }

    $('#btnUpdate').click(() => {
        // Need to check for type
        if ($typeSelect.value === 'team') {
            window.location.href = getUrl()
        } else {
            window.location.href = getPlayerUrl()
        }
    })
    $('#btnCSV').click(() => {
        window.location.href = `${getUrl()}&csv=true`
    })

    $(document).on('click', 'th.th-component-header', () => {
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        // populateUrl()
    })

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function cssAdder() {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })
})
